import { render, staticRenderFns } from "./ConfigurationWorkshop.vue?vue&type=template&id=e98c0db8&scoped=true&"
import script from "./ConfigurationWorkshop.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationWorkshop.vue?vue&type=style&index=0&id=e98c0db8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98c0db8",
  null
  
)

export default component.exports